import { render, staticRenderFns } from "./sup-vip-class-upgrading.vue?vue&type=template&id=6d925c2b"
import script from "./sup-vip-class-upgrading.vue?vue&type=script&lang=js"
export * from "./sup-vip-class-upgrading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports